<template>
  <div class="relative">
    <v-btn
      fab
      dark
      small
      @click="button.action"
      :style="{color: getTextColor(button.color), backgroundColor: button.color}"
    >
      <v-icon>{{button.icon}}</v-icon>
    </v-btn>
    <div v-if="button.text" class="fab-text" :style="textStyle" @click="button.action">
      {{button.text}}
    </div>
  </div>
</template>

<script>
  import { getTextColor } from '../../../HelperMethods'
  import Colors from '../../../mixins/Colors'

  export default {
    name: 'fab-button',
    props: {
      button: {
        required: true,
        type: Object
      },
      textDirection: {
        default: 'right'
      }
    },
    mixins: [Colors],
    data () {
      return {}
    },
    methods: {},
    computed: {
      textStyle () {
        const backgroundColor = this.button.backgroundColor || '#dfdfdf'
        return {
          backgroundColor: backgroundColor,
          color: getTextColor(backgroundColor),
          [this.textDirection]: '60px'
        }
      }
    },
    watch: {},
    mounted () {
      if (!this.button.action) {
        console.error('Please provide an action for the following FAB button.')
        console.warn(this.$el)
      }
    }
  }
</script>

<style scoped>
  .relative {
    position: relative;
  }

  .fab-text {
    position: absolute;
    white-space: nowrap;
    transform: translateY(-50%);
    top: 50%;
    padding: 0.25em 1em;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/misc/fab/FabButton.vue